import { getKnowledgesDE } from "./locales/knowledges_de";
import { getKnowledgesES } from "./locales/knowledges_es";
import { getKnowledgesFR } from "./locales/knowledges_fr";
import { getKnowledgesIT } from "./locales/knowledges_it";
import { getKnowledgesEN } from "./locales/knownledges_en";

export const getKnowledges = (lang) => {  
  if (lang?.id === "FRA") {
    return getKnowledgesFR();
  }
  if (lang?.id === "ENG") {
    return getKnowledgesEN();
  }
  if (lang?.id === "SPA") {
    return getKnowledgesES();
  }
  if (lang?.id === "ITA") {
    return getKnowledgesIT();
  }
  if (lang?.id === "DEU") {
    return getKnowledgesDE();
  }
  return getKnowledgesEN();
};
